import React, { useContext } from "react"
import { Link, useNavigate } from "react-router-dom"
import { SelectButton } from "primereact/selectbutton"

import { UserContext } from "../../../../context/userContext"

import styles from "../../../../styles/TwoFA.module.css"

import { getAuth } from "firebase/auth"

export default function EnabledMethods(props) {
  const { current2FAMethod, setCurrent2FAMethod } = props

  const userCtx = useContext(UserContext)

  const user = getAuth().currentUser
  const navigate = useNavigate()

  if (!user) return null
  if (!user?.emailVerified) return null

  const handleLabel = (method) => {
    switch (method) {
      case "phone":
        const hasSms = props.enrolledFactors.some(
          (factor) => factor.factorId === "phone"
        )
        if (hasSms) return "✓SMS"
        return "SMS"
      case "totp":
        const hasTotp = props.enrolledFactors.some(
          (factor) => factor.factorId === "totp"
        )
        if (hasTotp) return "✓TOTP"
        return "TOTP"
      default:
        return "Unknown"
    }
  }

  const hasBothMethods = props.enrolledFactors.length === 2

  return (
    <div className={styles.block}>
      <h2>Step 2: Enabled Methods</h2>
      {hasBothMethods ? (
        <div>
          ✅ Both methods are already enabled. You can set your preferred method
          in{" "}
          <strong>
            <Link
              to={`/form/account_preferences/1/${userCtx.session.user.staff_id_stamp}`}
              style={{ textDecoration: "underline" }}
            >
              Account preferences
            </Link>
          </strong>
          .
        </div>
      ) : (
        <div>Choose a 2FA method to setup:</div>
      )}

      <div>
        <div>
          <SelectButton
            value={current2FAMethod}
            options={[
              { label: handleLabel("phone"), value: "sms" },
              { label: handleLabel("totp"), value: "totp" },
            ]}
            onChange={(e) => {
              if (e.target === null) return null
              navigate(`?tab=${e.value}`)
              setCurrent2FAMethod(e.value)
            }}
            style={{ marginTop: 15 }}
          />
        </div>
      </div>
    </div>
  )
}
